export default __webpack_public_path__ + "static/speaker6-57762f8e6c8641086fa2ffb740f6fa89.jpg";